import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";
import DataApparatusLogo from "../icons/logos/logoNew.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <img src={DataApparatusLogo} alt="Data Apparatus" />
        <p>
          Governed data engineering for financial services, sustainability reporting,
          industrial operations, energy and analytics foundations.
        </p>
        <div className="footer-links">
          <Link to="/services/data-engineering">Services</Link>
          <Link to="/domain-expertise">Domain Expertise</Link>
          <Link to="/domain-expertise/financial-services">Financial Services</Link>
          <Link to="/domain-expertise/sustainability-reporting">Sustainability Reporting</Link>
          <Link to="/domain-expertise/construction">Industrial Operations</Link>
          <Link to="/integrations">Integrations</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <small>© {new Date().getFullYear()} Data Apparatus. All rights reserved.</small>
      </div>
    </footer>
  );
}
